/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".article[_ngcontent-%COMP%]{padding-top:1rem;padding-bottom:1rem;margin-top:1rem;margin-bottom:1rem}"];
export { styles as styles };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/contents/article-list/article-list.component.scss.shim.ngstyle.js.pre-build-optimizer.js